// 1) Primero los estilos (CSS compilado de Bootstrap + overrides SCSS + global)
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';

import '@/scss/custom-bootstrap.scss';
import '@/assets/global.css';
import '@/assets/theme-overrides.css';           // 4) CSS variables que forzan la paleta final

// 2) Luego el JS que incluye Popper y los plugins (dropdown, modal, etc.)
import 'bootstrap/dist/js/bootstrap.bundle';
// JavaScript de Bootstrap (ya incluye Popper) 
import 'bootstrap/dist/js/bootstrap.bundle.min.js'//este es para el menu desplegable
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js'



// 3) El resto de imports de Vue
import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index.js';
import store from './Vuex/store.js';
import axios from './axios';
import registerGlobalComponents from './global-components.js';
import { VueFlowPlugin } from '@vue-flow/core';
import '@vue-flow/core/dist/style.css';

import { BootstrapVueNext } from 'bootstrap-vue-next';

// Importa los estilos de Bootstrap y BootstrapVue

import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';



const app = createApp(App);
app.use(router);
app.use(store);
app.use(BootstrapVueNext);

window.bootstrap = bootstrap
app.use(VueFlowPlugin);
app.config.globalProperties.$axios = axios;
registerGlobalComponents(app);
app.mount('#app');
